import { render, staticRenderFns } from "./Internal.vue?vue&type=template&id=4ca57672&scoped=true&"
import script from "./Internal.vue?vue&type=script&lang=js&"
export * from "./Internal.vue?vue&type=script&lang=js&"
import style0 from "./Internal.vue?vue&type=style&index=0&id=4ca57672&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca57672",
  null
  
)

export default component.exports